import { render } from "./Storage.vue?vue&type=template&id=22a1bd6c"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"
script.render = render

export default script